import { ExternalStyles, Heading, Omit, useStyles } from 'bold-ui'
import React from 'react'
import { isUndefinedOrNull } from 'util/checks'

export interface BoxProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'style' | 'title'> {
  label?: string
  style?: ExternalStyles
  dataTestId?: string
}

export function Box(props: BoxProps) {
  const { label, style, dataTestId, ...rest } = props

  const { css, classes } = useStyles((theme) => ({
    box: {
      background: theme.pallete.surface.main,
      padding: '1rem',
      borderRadius: '2px',
      border: `1px solid ${theme.pallete.divider}`,
    },
    container: {
      position: 'relative',
      marginTop: '0.5rem',
      padding: '1.25rem 1rem 1rem 1rem',
    },
    title: {
      fontWeight: 'bold',
      position: 'absolute',
      top: '-0.75rem',
      marginLeft: '-0.75rem',
      padding: '0 0.5rem',
      backgroundColor: theme.pallete.surface.main,
    },
  }))

  if (!isUndefinedOrNull(label)) {
    const { children } = rest
    return (
      <div className={css(classes.box, classes.container, style)} data-testid={dataTestId} {...rest}>
        <Heading level={5} className={css(classes.title)}>
          {label}
        </Heading>
        {children}
      </div>
    )
  }

  return <div className={css(classes.box, style)} {...rest} data-testid={dataTestId} />
}
